import { shouldOfferPlannerOnboarding } from './store';

/**
 * Where a freshly created planner lands. Read at click time, before any planner
 * component has mounted. First-timers get the onboarding guide; everyone else
 * lands on the planner itself, with the Add button as the way in.
 *
 * Deliberately blind to `plannerOnboardingEnabled`: ConfigCat is only readable
 * from React, and the guide answers the launch itself when the flag turns out
 * to be off, so the kill switch stays whole either way.
 */
export const getNewPlannerParams = (
  userId: string | undefined
): Record<string, string> =>
  shouldOfferPlannerOnboarding(userId) ? { launch: 'planner-onboarding' } : {};

export const getNewPlannerLink = (
  editLink: string,
  userId: string | undefined
) => {
  const params = new URLSearchParams(getNewPlannerParams(userId)).toString();
  return params ? `${editLink}?${params}` : editLink;
};
